<template>
    <div>
        <p-header title="我的訂單" :backRouteLocation="{name: 'home'}"/>
        <div class="tabs">
            <div class="item" @click="tabChange('processing')" :class="{'selected': tabSelected === 'processing'}">
                進行中
            </div>
            <div class="item" @click="tabChange('history')" :class="{'selected': tabSelected === 'history'}">
                歷史記錄
            </div>
        </div>
        <div class="content">
            <transition name="component-fade" mode="out-in" appear>
                <component :is="tabName"/>
            </transition>
        </div>
    </div>
</template>

<script>
    import Header from './components/Header';
    import ProcessingOrders  from './components/order/list/ProcessingOrders';
    import HistoryOrders from './components/order/list/HistoryOrders';
    import { mapGetters } from 'vuex';

    export default {
        name: 'OrderList',
        components: {
            'p-header': Header,
            'processing-orders': ProcessingOrders,
            'history-orders': HistoryOrders,
        },
        data() {
            return {
                tabSelected: 'processing',
            }
        },
        computed: {
            tabName() {
                return this.tabSelected + '-orders';
            },
            ...mapGetters(['user', 'processing'])
        },
        methods: {
            tabChange(tag) {
                this.tabSelected = tag;
            },
        },
        beforeRouteEnter(to, from, next) {
            if (from.name !== 'order' && !from.meta.createOrderPage) {
                next(vm => {
                    vm.tabSelected = 'processing';
                });
            } else if (from.name === 'order') {
                let id = from.params.id;
                next(vm => {
                    let index = vm.processing.findIndex(order => {
                        return order.id == id;
                    });

                    if (index >= 0) {
                        vm.tabSelected = 'processing';
                    }
                });
            }
            next();
        }
    };
</script>

<style lang="scss" scoped>
    .tabs {
        display: flex;
        margin: 15px;

        .item {
            margin: 10px;
            font-size: 14px;
            font-weight: 500;
            line-height: 20px;
            position: relative;
            cursor: pointer;
            user-select: none;

            &::before {
                content: "";
                position: absolute;
                top: 0;
                left: 0;
                width: 0;
                height: 100%;
                border-bottom: 2px solid #339933;
                transition: 0.2s all linear;
            }

            &.selected {
                color: #339933;

                &::before {
                    width: 50%;
                }
            }


        }
    }

    .content {
        margin: 0 15px;
    }

    .component-fade-enter-active, .component-fade-leave-active {
        transition: opacity .3s ease;
    }
    .component-fade-enter, .component-fade-leave-to {
        opacity: 0;
    }
</style>
